import React, { useState } from 'react';
import { API_BASE_URL } from '../utils/apiBase';
import './OrderPage.css';

function OrderPage({ onBack }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    if (!trimmedName) { setError('Please enter your name.'); return; }
    if (!isValidEmail(trimmedEmail)) { setError('Please enter a valid email address.'); return; }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE_URL}/order-waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: trimmedName, email: trimmedEmail }),
      });
      if (!res.ok) {
        let body = null;
        try { body = await res.json(); } catch (_) { /* ignore */ }
        throw new Error((body && body.error) || `Server returned ${res.status}`);
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="order-page">
      <header className="order-header">
        <button className="order-back" onClick={onBack}>← Back</button>
        <h1>♜ Ranga</h1>
        <div style={{ width: '60px' }} />
      </header>

      <main className="order-main">
        <div className="order-card">
          <h2>Order a physical Ranga set</h2>
          <p className="order-lede">
            We're building physical Ranga boards and piece sets for play at home.
            Leave your name and email to be notified the moment they're available to order.
          </p>

          {submitted ? (
            <div className="order-success">
              <h3>You're on the list. 🎉</h3>
              <p>
                Thanks, {name}. We'll email <strong>{email}</strong> as soon as
                physical sets are available to order.
              </p>
              <button className="order-btn-secondary" onClick={onBack}>
                Back to home
              </button>
            </div>
          ) : (
            <form className="order-form" onSubmit={handleSubmit}>
              <label className="order-label">
                Name
                <input
                  type="text"
                  className="order-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  autoComplete="name"
                  required
                />
              </label>
              <label className="order-label">
                Email
                <input
                  type="email"
                  className="order-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  required
                />
              </label>
              {error && <div className="order-error">{error}</div>}
              <button
                type="submit"
                className="order-btn-primary"
                disabled={submitting}
              >
                {submitting ? 'Submitting…' : 'Notify me when available'}
              </button>
              <p className="order-fineprint">
                We'll only email you about Ranga set availability. No spam, no resale.
              </p>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}

export default OrderPage;
